import { gql } from "@apollo/client"

export const UPDATE_ODOMETER_MUTATION = gql`
    mutation UpdateVehicle($record: UpdateByIdVehicleInput!, $id: MongoID!) {
        updateVehicle(record: $record, _id: $id) {
            recordId
            record {
                _id
                odometer
            }
        }
    }
`
